import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { AnalyticsService } from '../../../shared/providers/analytics.service';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { ISaveRequestBov } from '../../../shared/models/SaveRequestBov';
import { PropertyStatus } from '../../../shared/enum/enum';
import { Observable, Subscription } from 'rxjs';

declare var require: any;
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
interface IWatchListData {
  name: string;
  Id: number;
  data: [];
}
interface IDropDownData {
  value: number;
  display: string;
  TypeId: number;
}
interface IMyTenants {
  Id: number;
  MyPropertyList?: [];
  ShowList: boolean;
  PropertyType?: string;
  TypeCurrentRate?: number;
  TypeIncrease?: number;
  TypeStatusId?: number;
  TotalRate?: number;
  TotalIncreased?: number;
  TotalStatusId?: number;
  AvailableProperties?: number;
  Name?: string;
  PropertyCount?: number;
  showOffMarketButton?: number;
  InfoText?: string;
  InfoTextTenant?: string;
}

@Component({
  selector: 'app-my-portfolio-properties',
  templateUrl: './my-portfolio-properties.component.html',
  styleUrls: ['./my-portfolio-properties.component.css']
})
export class MyPortfolioProperties implements OnInit, OnDestroy {
  currentMenu = '';
  constructor(private router: Router, private PropertyListing: PropertyListingService, private Analytics: AnalyticsService, private propertyService: PropertyListingService, private _toastService: ToastService, public Validation: ValidationService, private modalService: BsModalService, public authentication: AuthenticationService, private Loader: LoaderService) {
  }
  modalRef: BsModalRef;
  tenantlst: IDropDownData[];
  BovRequest: ISaveRequestBov = {} as any;
  tenants: any[];
  chartData: IWatchListData = {} as any;
  user: any;
  barChartData = [] as any;
  showAddwatchList: number = 0;
  PropertybarChartData1 = [] as any;
  PropertyDataList = [] as any;
  currentUser: any;
  Propertymonths = [];
  MyTenants: IMyTenants[];
  selectedTenants: number[] = [];
  watchlistcount = [];
  tenantIds = [];
  portfoliosummary = [] as any;
  currentTenantCount = 3;
  modalRefBov: BsModalRef;
  modalOffMarket: BsModalRef;
  propertyStatus = PropertyStatus
  requestedProperties = [] as any;
  @Input() UserGuid: string = '0000';
  @Input() PortfolioName: string = 'My Properties';
  Isdata: number = 0;
  IsGlobalData: number = 0;
  pendingProperties = [] as any;
  selectedPendindId: string;
  IsValid = true;
  IsShowMyproperty = 0;
  subscription1: Subscription[] = [];

  ngOnInit() {
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000'
    this.user = this.authentication.user;
    this.getMonths()
    this.getChartData();
    this.Isdata = 0
  }

  ngOnDestroy() {
    this.subscription1.forEach(sub => sub.unsubscribe());
  }

  getChartData() {
    this.subscription1.push(this.Analytics.GetMyPropertiesList(this.user.Id, this.UserGuid).subscribe(response => {
      let data = response;
      this.PropertybarChartData1 = data;
      if (data != null && data.length > 0) {
        let tenantData = data.filter(d => d.Id).map(i => i.Id);

        tenantData = tenantData.map(ar => JSON.stringify(ar))
          .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
          .map(str => JSON.parse(str));

        this.MyTenants = tenantData.map(o => ({ Id: o, MyPropertyList: [], ShowList: false, showOffMarketButton: 0 }))
        let tenantList = this.MyTenants != null && this.MyTenants.length > 0 ? this.MyTenants.length : 0;
        this.currentTenantCount = tenantList;
        if (tenantData != null) {
          let sourceData = data.filter(d => d.Id).map(i => i.PropertyOwner);
          if (sourceData[0] == 'NotOwner') {
            this.IsShowMyproperty = 1;
          }
          else {
            this.IsShowMyproperty = 2;
          }
        }
        else {
          this.IsShowMyproperty = 2;
        }
        setTimeout(() => { this.bindChart(); }, 500);
      }
      else {
        this.MyTenants = [];
        this.currentTenantCount = 0;
        this.IsShowMyproperty = 2;
      }
    }));
  }


  bindChart() {
    this.MyTenants.forEach(s => {
      this.getMyData(s);
    });
  }

  getMyData(myData: any) {
    let alldata = this.PropertybarChartData1;
    let i = 0;
    let minimumValue = 0;
    let categoryData = [];
    let informationText = '';
    const status = new Observable(subscriber => {
      subscriber.next(this.subscription1.push(this.propertyService.getPrincipalHighlight(myData.Id, this.user.Id, this.UserGuid).subscribe(response => {

        if (response != null) {
          if (response[0].PropertyCount != null) {
            myData.PropertyCount = response[0].PropertyCount;
          }
          categoryData = response;
          if (response[10].PropertyType != null) {
            myData.PropertyType = response[10].PropertyType;
            myData.TypeCurrentRate = parseFloat(response[11].AvgCapRate.toFixed(2));
            let previous = response[10].AvgCapRate;
            let current = response[11].AvgCapRate;
            if (current >= previous) {
              let difference = current - previous;
              let differenceText = difference.toFixed(2);
              if (difference > 0) {
                difference = parseFloat(difference.toFixed(2));
                informationText = 'The average asking cap rate has increased by ' + differenceText + ' % from the previous month.';
                myData.InfoText = informationText;
                myData.TypeStatusId = 1;
              }
              else {
                myData.TypeStatusId = 0;
                difference = parseFloat(difference.toFixed(2));
                informationText = 'The average asking cap rate has not changed from the previous month.';
                myData.InfoText = informationText;
              }
              myData.TypeIncrease = difference;
            }
            else {
              myData.TypeStatusId = 2;
              let difference = previous - current;
              let differenceText = difference.toFixed(2);
              if (difference > 0) {
                difference = parseFloat(difference.toFixed(2));
                informationText = 'The average asking cap rate has decreased by ' + differenceText + ' % from the previous month.';
                myData.InfoText = informationText;
              }
              else {
                difference = parseFloat(difference.toFixed(2));
                informationText = 'The average asking cap rate has not changed from the previous month.';
                myData.InfoText = informationText;
              }
              myData.TypeIncrease = difference;
            }
          }
        }
        let num = 0;
        let pointIncrease = 0;
        let tenantName = this.PropertybarChartData1.filter(x => x.Id == myData.Id).map(i => i.Name)[0];
        let propertymonthdata = [] as any;
        let propcategorychartdata = [] as any;
        let currentRating = 0;
        let previousMonthRating = 0;
        let categorychartname = response[0].PropertyType;
        let availableProp = 0;
        this.Propertymonths.forEach(t => {
          let propertydata1 = this.PropertybarChartData1.filter(x => x.Id == myData.Id);
          this.watchlistcount = num <= 12 ? propertydata1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0] : propertydata1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[1];
          if (num == 11) {
            currentRating = propertydata1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0];
            availableProp = propertydata1.filter(x => x.XAxis == t).map(i => i.ActiveListing)[0];
          }
          if (num == 10) {
            previousMonthRating = propertydata1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0];
          }
          propertymonthdata.push(this.watchlistcount);
          propcategorychartdata.push(response.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0]);
          num = num + 1;
        });
        this.PropertyDataList = [] as any;
        this.PropertyDataList = [{
          name: tenantName,
          data: propertymonthdata.map(i => i),
          color: '#02C29F',
          marker: {
            "symbol": "circle"
          }
        }];
        if (this.PropertyDataList != null && this.PropertyDataList != undefined && this.PropertyDataList.length > 0) {
          minimumValue = propertymonthdata.reduce((a, b) => Math.min(a, b));
        }
        let propertylistData1 = {} as any;
        if (categorychartname != null && categorychartname != undefined) {
          propertylistData1 = {
            name: categorychartname,
            color: '#FFC32B',
            data: propcategorychartdata.map(i => i),
            marker: {
              "symbol": "circle"
            }
          };
          this.PropertyDataList.push(propertylistData1);
          let newmin = propcategorychartdata.reduce((a, b) => Math.min(a, b));
          minimumValue = (propertymonthdata != null && propertymonthdata.length > 0) ? minimumValue > newmin ? newmin : minimumValue : newmin;
          minimumValue = minimumValue > 1 ? (minimumValue - 1) : minimumValue;
        }
        else {
          minimumValue = minimumValue > 1 ? (minimumValue - 1) : minimumValue;
        }

        const chart = {
          chart: {
            type: 'spline',
            height: 250,
          },

          title: {
            text: ''
          },
          xAxis: {
            categories: this.Propertymonths.map(i => i),
            crosshair: true,
            title: {
              text: ''
            },
            style: {
              fontSize: '12px'
            }

          },
          yAxis: {
            gridLineWidth: 0,
            minorGridLineWidth: 0,
            tickInterval: 0.5,
            min: minimumValue,
            title: {
              text: ''
            },
            labels: {
              format: '{value}%',
              style: {
                fontSize: '12px'
              }
            },
          },
          legend: {
            enabled: true,
            itemStyle: {
              fontWeight: 'normal',
              fontSize: '12px'
            }
          },
          credits: {
            enabled: false
          },

          tooltip: {
            headerFormat: '',
            pointFormatter: function () {
              var point = this;
              var currentSeries = point.series;
              if (currentSeries.name == tenantName) {
                let activelistingCount = alldata.filter(i => i.Id == myData.Id && i.XAxis == point.category).map(i => i.ActiveListing)[0];
                let year = alldata.filter(i => i.Id == myData.Id && i.XAxis == point.category).map(i => i.Year)[0];
                return '<table><tr><td padding:0"> ' + tenantName + ' : </td><td style="padding:0">' + point.category + ' ' + year + '</td></tr><tr><td padding:0"> # Properties : </td><td style="padding:0"><b>' + activelistingCount + '</b></td></tr><tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + '%</b></td></tr>';
              }
              else {
                let activelistingCount = categoryData.filter(i => i.XAxis == point.category).map(i => i.ActiveListing)[0];
                let year = categoryData.filter(i => i.XAxis == point.category).map(i => i.Year)[0];
                return '<table><tr><td padding:0"> ' + categorychartname + ' : </td><td style="padding:0">' + point.category + ' ' + year + '</td></tr><tr><td padding:0"> # Properties : </td><td style="padding:0"><b>' + activelistingCount + '</b></td></tr><tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + '%</b></td></tr>';
              }
            },
            footerFormat: '</table>',
            distance: 30,
            shared: false,
            useHTML: true,
            shadow: false,

          },
          plotOptions: {
            line: {
              lineWidth: 2,
              states: {
                hover: {
                  lineWidthPlus: 1,
                },
              },
            },
          },
          series: this.PropertyDataList
        }
        if (currentRating >= previousMonthRating) {
          pointIncrease = currentRating - previousMonthRating;
          let pointIncreaseText = pointIncrease.toFixed(2);
          if (pointIncrease > 0) {
            pointIncrease = parseFloat(pointIncrease.toFixed(2));
            informationText = 'The average asking cap rate has increased by ' + pointIncreaseText + ' % from the previous month.';
            myData.TotalStatusId = 1;
            myData.InfoTextTenant = informationText;
          }
          else {
            informationText = 'The Average Asking Cap Rate has not changed from the previous month.';
            myData.InfoTextTenant = informationText;
            myData.TotalStatusId = 0;

          }
        }
        else {
          pointIncrease = previousMonthRating - currentRating;
          let pointIncreaseText = pointIncrease.toFixed(2);
          if (pointIncrease > 0) {
            pointIncrease = parseFloat(pointIncrease.toFixed(2));
            informationText = 'The average asking cap rate has decreased by ' + pointIncreaseText + ' % from the previous month.';
            myData.InfoTextTenant = informationText;
          }
          myData.TotalStatusId = 2;
        }
        let newId = 'PropertyContainer' + myData.Id;
        let mainDiv = 'PropertyhighchartGraph' + myData.Id;
        let chartDiv = document.getElementById(mainDiv);
        if (chartDiv != null && chartDiv != undefined) {
          document.getElementById(mainDiv).style.display = 'block';
        }
        myData.TotalRate = parseFloat(currentRating.toFixed(2));
        myData.TotalIncreased = parseFloat(pointIncrease.toFixed(2));
        myData.AvailableProperties = availableProp;
        myData.Name = tenantName;
        i = i + 1;
        if (document.getElementById(newId)) {
          Highcharts.chart(newId, chart);
        }
      })));
    });
    status.subscribe(x => {
    });
  }
  getMonths() {
    let currentYear = new Date().getFullYear();
    var today = this.Validation.convertUTCDateToLocalDate1(new Date());
    let range = [];
    var newDate = today;
    let selectedValue = 11;
    let monthDigit = newDate.getMonth() - selectedValue;
    newDate = new Date(newDate.getFullYear(), monthDigit, 1);
    for (var i = newDate; i <= new Date(); i.setMonth(newDate.getMonth() + 1)) {
      var month = i.toLocaleString('en-us', { month: 'short' });;
      range.push(month);
    }
    this.Propertymonths = range;
  }

  expandChart(div) {
    if ($('#' + div).hasClass('expand-div')) {
      window.scrollTo(0, 0);
      $('#' + div).removeClass('expand-div');
      $('body').removeClass('modal-open');

    }
    else {
      window.scrollTo(0, 0);
      $('#' + div).addClass('expand-div');
      $('body').addClass('modal-open');
    }
    this.getChartData();
  }

  getMyProperties(tenantId: number, index: number, properties: any) {
    this.Isdata = 0;
    if (properties != null && properties != undefined) {
      properties.MyPropertyList = [];
      if (!properties.ShowList) {
        if (properties.MyPropertyList == null || properties.MyPropertyList == undefined || properties.MyPropertyList.length == 0) {
          this.propertyService.getPrincipalProperties(tenantId, this.user.Id, this.UserGuid).subscribe(response => {
            if (response != null) {
              let portfolioProperties = response.filter(f => f.PropertyId == 0 && (f.DataentryPropertyStatusId == this.propertyStatus.Draft || f.DataentryPropertyStatusId == this.propertyStatus.Rejected));
              if (portfolioProperties != null && portfolioProperties.length > 0) {
                properties.showOffMarketButton = 1;
              }
              properties.MyPropertyList = response;
              this.requestedProperties = properties.MyPropertyList;
              properties.ShowList = true;
            }
          });
        }
        else {
          properties.ShowList = true;
        }
      }
      else {
        properties.ShowList = false;
      }
    }
  }

  getHightlightData(tenantId: number, index: number, mydata: any) {
    this.propertyService.getPrincipalHighlight(tenantId, this.user.Id, this.UserGuid).subscribe(response => {
      if (response != null) {
        if (response[10].PropertyType != null) {
          mydata.PropertyType = response[10].PropertyType;
          mydata.TypeCurrentRate = response[11].AvgCapRate;
          let previous = response[10].AvgCapRate;
          let current = response[11].AvgCapRate;
          if (current >= previous) {
            mydata.TypeStatusId = 1;
            let difference = current - previous;
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2));
              mydata.TypeStatusId = 1;
            }
            else {
              mydata.TypeStatusId = 0;

            }
            mydata.TypeIncrease = difference;
          }
          else {
            mydata.TypeStatusId = 2;
            let difference = previous - current;
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2))
            }
            mydata.TypeIncrease = difference;
          }
        }
        if (response[0].PropertyCount != null) {
          mydata.PropertyCount = response[0].PropertyCount;
        }
      }
    });
  }

  RequestBov(propertyId: string = '', template: TemplateRef<any>, classes: any) {

    if (propertyId != null && propertyId != '' && propertyId != undefined && propertyId != '0') {
      var element = <HTMLInputElement>document.getElementById("btnExcel1");
      element.disabled = true;
      this.IsGlobalData = 1;
    }
    else {
      var element = <HTMLInputElement>document.getElementById("btnExcel");
      element.disabled = true;
      this.IsGlobalData = 2;
    }
    this.selectedRows = [];
    this.propertyService.getPrincipalProperties(0, this.user.Id, this.UserGuid).subscribe(response => {
      this.requestedProperties = response;
      if (this.requestedProperties != null && this.requestedProperties.length > 0 && this.requestedProperties != undefined) {
        this.requestedProperties = this.requestedProperties.filter(r => r.DataentryPropertyStatusId != 6949);
      }
      if (propertyId == '') {
        this.requestedProperties.forEach(s => {
          s.IsChecked = true;
          this.selectedRows.push(s);
        });
        this.selectAll = true;
      }
      else {
        if (this.requestedProperties.findIndex(x => x.Guid == propertyId) > -1) {
          this.requestedProperties.find(x => x.Guid == propertyId).IsChecked = true;
          let prop = this.requestedProperties.find(x => x.Guid == propertyId);
          this.selectedRows.push(prop);
        }
        this.selectAll = false;
      }

      this.modalRefBov = this.modalService.show(template, { class: classes });
    });
  }
  selectedRows = [];
  onCheckboxChange(event, Id) {
    if (event) {
      let prop = this.requestedProperties.find(x => x.Guid == Id);
      this.selectedRows.push(prop);
    }
    else {
      if (this.selectedRows.findIndex(x => x.Guid == Id) > -1) {
        let index = this.selectedRows.findIndex(x => x.Guid == Id);
        this.selectedRows.splice(index, 1);
      }
    }
  }
  SubmitBovRequest() {
    if (this.selectedRows != null && this.selectedRows.length > 0) {
      this.Loader.display(true);
      this.BovRequest.PropertyIds = this.selectedRows.map(o => o.Guid);
      this.BovRequest.SellerId = this.user.Id;
      this.BovRequest.UserGuid = this.UserGuid;
      this.PropertyListing.SavePortfolioBov(this.BovRequest).subscribe(res => {
        if (res["Success"]) {
          this.Isdata = 1
          this.MyTenants.forEach(item => {
            if (this.selectedRows.findIndex(o => o.Guid == item.Id)) {
              item.ShowList = false;
            }
          });
          this._toastService.addToast({ title: 'Success', msg: 'BOV Requested successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.modalRefBov.hide();
          this.selectedRows = [];
          this.Loader.display(false);
          if (this.IsGlobalData == 1) {
            var element = <HTMLInputElement>document.getElementById("btnExcel1");
            element.disabled = false;
            this.IsGlobalData = 0;
          }
          else if (this.IsGlobalData == 2) {
            var element = <HTMLInputElement>document.getElementById("btnExcel");
            element.disabled = false;
            this.IsGlobalData = 0;
          }
        }
        else {
          this.Isdata = 0
          this.Loader.display(false);
          if (this.IsGlobalData == 1) {
            var element = <HTMLInputElement>document.getElementById("btnExcel1");
            element.disabled = false;
            this.IsGlobalData = 0;
          }
          else if (this.IsGlobalData == 2) {
            var element = <HTMLInputElement>document.getElementById("btnExcel");
            element.disabled = false;
            this.IsGlobalData = 0;
          }
          this._toastService.addToast({ title: 'Error Occurred', msg: res["ReturnMsg"], timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      });

    }
    else {
      this._toastService.addToast({ title: 'Error', msg: 'Please select at least one property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }
  contactBroker() {
    this.PropertyListing.ContactBovBroker(this.user.Id, this.UserGuid).subscribe(response => {
      this._toastService.addToast({
        title: 'Success',
        msg: `Your request has been successfully submitted. The B+E team will get in touch with you shortly`,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
      this.modalRefBov.hide();
      this.selectedRows = [];
    });
  }

  selectAll = false;
  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.requestedProperties.forEach(item => {

      item.IsChecked = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.Guid == item.Guid) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Guid == item.Guid), 1);
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }

  }
  modelClose() {
    if (this.IsGlobalData == 1) {
      var element = <HTMLInputElement>document.getElementById("btnExcel1");
      element.disabled = false;
      this.IsGlobalData = 0;
    }
    else if (this.IsGlobalData == 2) {
      var element = <HTMLInputElement>document.getElementById("btnExcel");
      element.disabled = false;
      this.IsGlobalData = 0;
    }
    this.Isdata = 0;
  }

  OnClickOffMarket(propertyId: number, template: TemplateRef<any>, classes: any, properties: any) {
    this.selectedPendingProperty = {} as any;
    this.selectedPendindId = null;
    if (properties != null && properties.length > 0 && propertyId != null && propertyId > 0) {
      let portfolioProperties = properties.filter(f => f.PropertyId == 0 && (f.DataentryPropertyStatusId == this.propertyStatus.Draft || f.DataentryPropertyStatusId == this.propertyStatus.Rejected));
      if (portfolioProperties != null) {
        if (portfolioProperties.length > 0 && portfolioProperties != undefined) {
          portfolioProperties = portfolioProperties.filter(r => r.DataentryPropertyStatusId != 6949);
        }
        this.pendingProperties = portfolioProperties;
        this.modalOffMarket = this.modalService.show(template, { class: classes });
      }
    }
  }

  selectedPendingProperty = {} as any;
  onPropertyChanges() {
    this.selectedPendingProperty = {} as any;
    this.IsValid = true;
    if (this.selectedPendindId != null && this.selectedPendindId != '') {
      let selectedProp = this.pendingProperties.filter(f => f.Guid == this.selectedPendindId)[0];
      selectedProp.Remaining_Term = this.Validation.remainingTermForCardandTables(selectedProp.LeaseExpiration, selectedProp.LeaseCommencementDate);
      this.selectedPendingProperty = selectedProp;
    }
  }

  proceedPricing() {
    if (this.selectedPendindId != null && this.selectedPendindId != '') {
      document.getElementById("openModalChangeToOffMarketButton").click();
      this.modalOffMarket.hide();
    }
    else {
      this.IsValid = false;
    }
  }

  openModalForQuickEdit(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  closeModal($event) {
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
  }
  closeButtonModel($event) {
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigateByUrl(url));
  }


  onclickEditProperty() {
    if (this.selectedPendindId != null && this.selectedPendindId != '') {
      this.modalOffMarket.hide();
      let portfolio = this.PortfolioName == 'My Properties' ? 'My Portfolio' : this.PortfolioName + "'s Portfolio";
      this.router.navigate(['/portfolio-principal-property/' + this.selectedPendindId], { queryParams: { UserGuid: this.UserGuid, IsmyPortfolio: true, prevroute: 'Market Snapshot' } });
    }
    else {
      this.IsValid = false;
    }
  }

  openAddNewProperty() {
    this.router.navigate(['/portfolio-principal-property'], { queryParams: { prevroute: 'Market Snapshot', link: 'market-snapshot', UserGuid: this.UserGuid } });
  }
}
